<template>
  <s-table
    :key="invoiceData.timologioId"
    @input="handleTransctions"
    v-if="loaded"
    rowKeyField="transactionId"
    :topOffset="190"
    heightWish="90%"
    :pagging="1000"
    v-model="transactions"
    :allwaysEdit="true"
    :edit-disabled="disabled"
    :colDefinitions="colDefinitions"
    modx-processor="transaction/getlist"
    :r-query="qTransactions"
    :lazyLoader="false"
    :addEmptyLine="true"
    @cell-change="handleTransaction"
    @cell-clicked="removeTrans"
  ></s-table>
</template>

<script>
import _ from "lodash";
import * as api from "~/api/resource";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "transactions-panel",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    invoiceData: {
      type: Object,
      default: () => {}
    },
    businessId: {
      default: null
    }
  },
  data() {
    return {
      updating: false,
      transactions: [],
      userProfile: UserProfile,
      dateFormat: "DD/MM/YY"
    };
  },
  watch: {
    transactions: {
      handler(val) {
        _log_(">>Q>>>",val, this.qTransactions);
        if (val && val.length) {
          const vm = this;
          vm.$emit("transctionsChanged", vm.transactions);
        }
      },
      deep: true
    },
    async "invoiceData.vat"(val, oldvl) {
      _log_(">>>VAT>>", val);
      if (val == oldvl) return;
      const vm = this;
      this.transactions.forEach(tr => {
        if (vm.invoiceData.timologioId != tr.timologioId) return;
        if (tr.transactionId && tr.transactionId != "")
          vm.handleTransaction({ row: tr }, val);
      });
    }
    // async businessId(newVal, oldVal) {
    //   if (newVal != oldVal) {
    //     var { data } = await api.fetchProcessor("business/get", {
    //       objectId: this.invoiceData.businessId
    //     });
    //     this.businessData = data.object;
    //     // this.selectedBusiness = JSON.parse(JSON.stringify(data.object));
    //   }
    // }
  },
  computed: {
    loaded() {
      if (!this.invoiceData) return false;
      else return true;
    },
    qTransactions() {
      if (this.invoiceData) return { objectId: this.invoiceData.timologioId };
      else return null;
    },

    colDefinitions() {
      const vm = this;
      // _log_(">>>>>", this.invoiceData);
      if (Receipt.team == "medcare")
        return [
          // { prop: "transactionId", width: "", editable: false, label: "id" },
          {
            prop: "description",
            width: "",
            editable: true,
            editorcomponent: {
              is: "el-input",
              type: "textarea",
              autosize: { minRows: 2, maxRows: 4 }
            },
            label: "Περιγραφη"
          },

          {
            prop: "cost",
            width: "120px",
            editable: true,
            label: "Κοστος",
            formatter(val, colDefs, row) {
              return vm.$theMoney(val) + "&euro;";
            }
          },

          {
            prop: "costincl",
            width: "120px",
            editable: true,
            label: "Με ΦΠΑ",
            formatter(val, colDefs, row) {
              return vm.$theMoney(val) + "&euro;";
            }
          },
          {
            prop: "transactionId",
            width: "60px",
            label: "X",
            onlyEditMode: true,
            editable: true,
            sortable: false,
            editorcomponent: {
              is: "el-button",
              icon: "el-icon-delete",
              type: "danger",
              circle: true
            },
            formatter(val, colDefs, row) {
              return "-";
              // return '<button type="button" class="el-button el-button--default is-circle"><i class="el-icon-close"></i></button>';
            }
          }
        ];
      var possibleConfiguration = this.transactionConfiguration(Receipt.team);
      if (possibleConfiguration)
        possibleConfiguration = possibleConfiguration[this.invoiceData.kind]
          ? possibleConfiguration[this.invoiceData.kind]
          : possibleConfiguration.default;
      if (possibleConfiguration)
        return possibleConfiguration[this.invoiceData.timo_group]
          ? possibleConfiguration[this.invoiceData.timo_group]
          : possibleConfiguration;
      // if (Receipt.team == "kriton" && this.invoiceData.kind == "receipt")
      //   return;
      return [
        // { prop: "transactionId", width: "", editable: false, label: "id" },
        { prop: "description", width: "", editable: true, label: "Περιγραφη" },

        {
          prop: "cost",
          width: "120px",
          editable: true,
          label: "Κοστος",
          editorcomponent: {
            is: "s-number"
          },
          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          }
        },

        {
          prop: "costincl",
          editorcomponent: {
            is: "s-number"
          },
          width: "120px",
          editable: true,
          label: "Με ΦΠΑ",
          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          }
        },
        {
          prop: "transactionId",
          width: "60px",
          label: "X",
          onlyEditMode: true,
          editable: true,
          sortable: false,
          editorcomponent: {
            is: "el-button",
            icon: "el-icon-delete",
            type: "danger",
            circle: true
          },
          formatter(val, colDefs, row) {
            return "-";
          }
        }
      ];
    },
    ...mapGetters({
      transactionConfiguration: "user/transactionConfiguration"
    })
  },
  mounted() {
    _log_("trans.ss.REMOUNT ii..", this.qTransactions);
  },
  methods: {
    init() {},
    removeTrans(e) {
      _log_("trans.ss.go ii..", e);
      if (!this.disabled && e.column.property == "transactionId") {
        if (!e.row.transactionId) return;
        api.removeObject("transaction", { objectId: e.row.transactionId });
        this.removeArrayElement(this.transactions, e.row, "transactionId");
      }
    },
    async handleTransaction(e, forceVAT) {
        _log_(
        "trans.ss.A.." + e.prop + " .. " ,
        e,
        this.transactions
      );
      e.row.timologioId = this.invoiceData.timologioId;
      var validVAT = forceVAT;
      if (forceVAT) e.row.vat = forceVAT;
      else
        validVAT =
          parseFloat(e.row.vat ? e.row.vat : this.invoiceData.vat) / 100;

      if (!e.row.quantity) e.row.quantity = 1;
      if (e.prop == "unitcost" || e.prop == "quantity") {
        e.row.cost = parseFloat(e.row.unitcost) * parseFloat(e.row.quantity);
        e.row.costincl = parseFloat(e.row.cost) * (1 + validVAT);
      }
      if (e.prop == "costincl") {
        e.row.cost = parseFloat(e.row.costincl) / (1 + validVAT);
        e.row.unitcost = e.row.cost / e.row.quantity;
      }
      if (e.prop == "cost") {
        e.row.costincl = parseFloat(e.row.cost) * (1 + validVAT);
        // e.row.unit = 1;
        e.row.unitcost = e.row.cost / e.row.quantity;
      }
      var transIndex = null;
      if (e.row.transactionId)
        transIndex = _.findIndex(this.transactions, {
          transactionId: e.row.transactionId
        });
      else
        transIndex = _.findIndex(this.transactions, function(o) {
          return !o.transactionId;
        });

      //this is handled in the server
      delete e.row.usergroupId;
      delete e.row.userId;
      delete e.row.teamId;
      if (!e.row.cost) e.row.cost = 0;
      if (!e.row.vat&&this.invoiceData.vat) e.row.vat = this.invoiceData.vat;
      if (!e.row.unitcost) e.row.unitcost = 0;
      if (!e.row.costincl) e.row.costincl = 0;
      var { data } = await api.fetchProcessor("transaction/update", e.row);

      if (!data.object.cost) data.object.cost = "";

      if (!data.object.costincl) data.object.costincl = "";

      data.object[e.prop] = this.transactions[transIndex][e.prop]; //handles delay
      this.$set(this.transactions, transIndex, data.object);
      // this.$emit("transctionChanged", data.object)
      _log_("trans.ss.BB..", this.transactions);

    },
    handleTransctions(e) {
      // _log_("trans..B..", e);
    }
  }
};
</script>
